module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/mindful/Room_mindful_02slide_04.png";